document.addEventListener('DOMContentLoaded', () => {
  if (!window.gsap || !window.ScrollTrigger || !window.ScrollToPlugin) return;
  gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

  const sections = document.querySelectorAll('.section-our-journey');

  sections.forEach((section) => {
    const navItems = Array.from(section.querySelectorAll('.journey__nav__list__item'));
    const pin      = section.querySelector('.journey__pin');
    const track    = section.querySelector('.journey__track');
    const panels   = Array.from(section.querySelectorAll('.journey__track__panel'));

    const getTallest = () => Math.max(...panels.map(p => p.offsetHeight || 0));
    const setPinHeight = () => { pin.style.height = getTallest() + 'px'; };

    const getMaxShift = () => Math.max(0, track.scrollWidth - pin.clientWidth);
    const getSnapPoints = () => {
      const maxShift = getMaxShift();
      if (maxShift === 0) return [0];
      return panels.map(p => Math.min(1, Math.max(0, p.offsetLeft / maxShift)));
    };
    const getNearestIndex = (v, arr) => {
      let idx = 0, best = 1e9;
      for (let i = 0; i < arr.length; i++) {
        const d = Math.abs(v - arr[i]);
        if (d < best) { best = d; idx = i; }
      }
      return idx;
    };
    const updateActive = (idx) => {
      navItems.forEach((btn, i) => {
        const active = i === idx;
        btn.classList.toggle('active', active);
        btn.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    };

    setPinHeight();

    const horizTween = gsap.to(track, {
      x: () => -getMaxShift(),
      ease: 'none',
      paused: true
    });

    let snapPoints    = getSnapPoints();
    let lastDirection = 1;
    let isProgrammatic = false;
    let forcedIndex    = null;

    const st = ScrollTrigger.create({
      trigger: section,
      start: 'top top',
      end: () => '+=' + getMaxShift(),
      pin: section,
      scrub: true,
      anticipatePin: 1,
      invalidateOnRefresh: true,
      onUpdate(self) {
        horizTween.progress(self.progress);
        lastDirection = self.direction;
        updateActive(getNearestIndex(self.progress, snapPoints));
      },
      onRefresh(self) {
        setPinHeight();
        snapPoints = getSnapPoints();
        updateActive(getNearestIndex(self.progress, snapPoints));
      }
    });

    const EDGE = 0.03;
    const EPS  = 0.001;

    const snapToIndex = (idx, duration = 0.4) => {
      idx = Math.max(0, Math.min(idx, snapPoints.length - 1));
      const targetProg   = snapPoints[idx];
      const totalScroll  = st.end - st.start;
      const targetScroll = st.start + targetProg * totalScroll;
      gsap.to(window, {
        scrollTo: targetScroll,
        duration,
        ease: 'power3.out',
        autoKill: false,
        overwrite: 'auto'
      });
    };

    const onScrollEnd = () => {
      if (isProgrammatic) {
        if (forcedIndex != null) snapToIndex(forcedIndex, 0.2);
        return;
      }
      if (!st.isActive()) return;
      const prog = st.progress;
      if (prog <= EDGE || prog >= 1 - EDGE) return;

      const idx   = getNearestIndex(prog, snapPoints);
      const delta = prog - snapPoints[idx];
      if (Math.abs(delta) <= EPS) return;

      const nextIdx = lastDirection > 0
        ? Math.min(idx + 1, snapPoints.length - 1)
        : Math.max(idx - 1, 0);

      snapToIndex(nextIdx, 0.35);
    };

    ScrollTrigger.addEventListener('scrollEnd', onScrollEnd);

    navItems.forEach((btn, i) => {
      btn.addEventListener('click', () => {
        const maxShift     = getMaxShift();
        const targetX      = Math.min(maxShift, panels[i].offsetLeft);
        const targetProg   = maxShift ? (targetX / maxShift) : 0;
        const targetScroll = st.start + targetProg * (st.end - st.start);
        isProgrammatic = true;
        forcedIndex    = i;
        gsap.to(window, {
          scrollTo: targetScroll,
          duration: 0.6,
          ease: 'power2.out',
          autoKill: false,
          overwrite: 'auto',
          onComplete: () => {
            gsap.delayedCall(0.05, () => {
              isProgrammatic = false;
              forcedIndex = null;
            });
          }
        });
      });
    });

    let rAF, lastW = window.innerWidth;
    const onResize = () => {
      cancelAnimationFrame(rAF);
      rAF = requestAnimationFrame(() => {
        const w = window.innerWidth;
        if (w !== lastW) {
          lastW = w;
          setPinHeight();
          st.refresh();
        } else {
          setPinHeight();
        }
      });
    };
    window.addEventListener('resize', onResize);

    const ro = new ResizeObserver(() => { setPinHeight(); });
    panels.forEach(p => ro.observe(p));
  });
});
